<template>
  <div class="search-panel-container">
    <div class="search-panel">
      <LazySearchPanelLocations @update="setLocationObject" domain="activity"/>
<!--      <div class="vr"></div>-->
<!--      <SingleCalendar :single-date="true"/>-->
<!--      <div class="vr"></div>-->
      <button
          @click="search"
          :class="['btn btn-primary search-btn', {'tripening-search': $siteConfig.brand !== 'BookDirect'}]"
      >
        <span class="icon icon-search"></span>
        {{$t('Search')}}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSearchStore} from "~/store/search";
import { useRouter, useRoute } from "vue-router";

// import SingleCalendar from "~/components/SearchPanel/SingleCalendar.vue";
const _router = useRouter();
const route = useRoute()
const localePath = useLocalePath()

const searchStore = useSearchStore();
const { $siteConfig } = useNuxtApp()

const selectedLocation = ref<Object | null>(null);
let isRequestContinue = false;
const loadMoreTimeout = ref(null)
const setLocationObject = (location: any) => {
  if (location.geo_place) {
    searchStore.selectedCity = location.geo_place
    searchStore.selectedLocation = location.geo_place
  } else {
    searchStore.selectedCity = location
    searchStore.selectedLocation = location
  }
  selectedLocation.value  = location;
};



function search() {

  //validation
  if (!selectedLocation.value) {
    console.log('Please select a location')
    return;
  }

  const params = {
    criteria: searchStore.criteria,
    filters: {
      geo_place_id: searchStore?.selectedCity?.id,
    }
  }

  setQueryParams();
};

function createDynamicParams() {

  const _query = route.query
  const _params = route.params

  let params = {
    ..._query,
    citySlug: _params.city || searchStore?.selectedCity?.slug,
  }
  return params
}

async function getActivities(page?:number) {
  let params = createDynamicParams()

  try {
    const res = await searchStore.searchActivities(params)
    if (!res) await searchStore.searchActivities(params)
    isRequestContinue = false

  } catch(err) {
    console.log(err)
    isRequestContinue = false
  }
}

function setQueryParams() {
  let routeSlug = ''
  const query = {..._router.currentRoute.value.query, page: 1}
  if ((selectedLocation.value as any)?.geo_place) {
    routeSlug = (selectedLocation.value as any)?.geo_place?.slug
  } else {
    routeSlug = (selectedLocation.value as any)?.slug
  }

  _router.push(localePath({path: `/experiences/${routeSlug}`, query: {...query}}))
}

watch(
    () => _router.currentRoute.value,
    (newQuery, oldQuery) => {
      searchStore.clearActivityResults()
      getActivities()
    }
);
</script>

<style lang="scss">
$blackColorFilter: brightness(0) saturate(100%) invert(18%) sepia(0%) saturate(1189%) hue-rotate(154deg) brightness(92%) contrast(101%); //#292929

.search-input {
  display: flex;
  background: var(--white);
  position: relative;
  padding: 8px 16px;
  height: 56px;
  border-radius: 6px;
  border: 2px solid transparent;

  //tablet
  @media (max-width: 1024px) {
    padding: 8px 4px;
  }

  &:hover, &:focus {
    background-color: var(--light-grey);
    .search-input__input--placeholder {
      color: var(--black);
      font-weight: 500;
    }
  }

  &.in-focus, &.open {
    background-color: var(--white) !important;
    border-color: var(--blue);
  }

  &__icon {
    filter: $blackColorFilter;
    color: var(--black);
    font-size: 24px;
  }

  &__input {
    border: none;
    outline: none;
    width: 100%;
    text-align: left;
    background: transparent;
    color: var(--black);

    &--placeholder {
      color: var(--dark-grey);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  &__label {
    position: absolute;
    top: 8px;
    left: 48px;
    color: var(--dark-grey);
    font-size: 12px;
    font-weight: 400;
    line-height: 133.333%;

    //tablet
    @media (max-width: 1024px) {
      left: 36px;
    }

  }

  &__body {
    margin-top: 16px;
    display: flex;
    gap: 8px;
    width: 100%;
  }
}
</style>

<style scoped lang="scss">
.search-panel-container {
  background: var(--light-grey);
  border-bottom: 1px solid var(--grey-border);
  width: 100%;
  padding: 20px 0;

  :root[data-theme="dark"] & {
    background: var(--light-grey);
  }

  .search-panel {
    background: var(--white);
    border: 1px solid var(--grey-border);
    padding: 12px;
    display: flex;
    align-items: center;
    gap: 4px;
    border-radius: 10px;
    width: 100%;
    max-width: 1120px;
    margin: 0 auto;


    //tablet
    @media (max-width: 1024px) {
      flex-direction: column;
    }

    & > div {
      //tablet
      @media (max-width: 1024px) {
        width: 100%;
      }
    }

    :global(.locations) {
      flex: 1;
    }

    .vr {
      background-color: var(--grey-border);
      width: 1px;
      height: 56px;
      @media (max-width: 1024px) {
        width: 100%;
        height: 1px;
      }
    }
  }
  @media (max-width: 1024px) {
    padding: 20px 16px;
  }
}

.search-btn {
  width: 135px;
  height: 56px;
  font-size: 20px;
  font-weight: 600;
  line-height: 120%;


  &.tripening-search {
    border-radius: 4px;
    background-color: var(--blue);
  }

  //tablet
  @media (max-width: 1024px) {
    max-width: 100%;
    width: 100%;
    margin-top: 8px;
  }

  .icon {
    font-size: 24px;
    margin-right: 2px;
  }
}
</style>
